var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-add-btn"},[_c('router-link',{staticClass:"bottom-add-btn__inner",attrs:{"to":_vm.to,"tabindex":"-1"}},[_c('span',{class:_vm.icon})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }